import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LandingPageComponent } from './landing-page.component';
import { TranslateModule } from "@ngx-translate/core";
import { MatExpansionModule } from "@angular/material/expansion";
import { ButtonModule } from "@valg-shared/components/input/button/button.module";
import { PipesModule } from "@valg-shared/pipes/pipes.module";
import { MatIconModule } from "@angular/material/icon";


@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    MatExpansionModule,
    ButtonModule,
    PipesModule,
    MatIconModule
  ],
  declarations: [
    LandingPageComponent
  ]
})
export class LandingPageModule {
}
